/* eslint-disable react/jsx-no-target-blank */
import React from 'react';
import PropTypes from 'prop-types';
import { useMediaQuery } from 'react-responsive';

import getUserNameInitials from 'common/util/getUserNameInitials';

import { formatPhoneNumber } from 'common/formatters';

import { MEDIA_QUERY_SMALL_SCREEN } from 'client/constants/mediaQueries';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import SrFlex from 'client/components/SrFlex';

import './SrSimpleContactCard.less';

const SrSimpleContactCard = ({ name, phone, email }) => {
  const isSmallScreen = useMediaQuery({
    query: MEDIA_QUERY_SMALL_SCREEN,
  });

  return (
    <SrFlex
      align="center"
      boxShadow="0px 5px 21px rgba(25, 51, 64, 0.05)"
      backgroundColor="white"
      borderRadius={isSmallScreen ? '14px' : '24px'}
      padding={isSmallScreen ? '20px' : '26px 20px 31px 20px'}
    >
      <SrBox styleName="initials" marginRight="14px">
        <span>{getUserNameInitials(name)}</span>
      </SrBox>
      <SrBox>
        <SrText
          display="block"
          font="greycliff"
          weight="800"
          size="16"
          lineHeight="25px"
          color="blueGreycliff"
        >
          {name}
        </SrText>
        <SrBox
          overflow="hidden"
          textOverflow="ellipsis"
          opacity="0.5"
          width="calc(100vw - 120px)"
          maxWidth="380px"
        >
          <SrText
            font="greycliff"
            weight="600"
            size="16"
            lineHeight="25px"
            color="blueGreycliff"
            whiteSpace="nowrap"
          >
            {email}
          </SrText>
        </SrBox>
        <SrText
          display="block"
          font="greycliff"
          weight="600"
          size="16"
          lineHeight="25px"
          color="blueGreycliff"
          opacity="0.5"
        >
          {formatPhoneNumber(phone)}
        </SrText>
      </SrBox>
    </SrFlex>
  );
};

SrSimpleContactCard.propTypes = {
  name: PropTypes.string.isRequired,
  phone: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
};

SrSimpleContactCard.displayName = 'SrSimpleContactCard';

export default SrSimpleContactCard;
